export const CLASS_BLOCK = "CameraActivity_Block";
export const CLASS_INLINE = "CameraActivity_BlockInline";
export const CLASS_FLEX = "CameraActivity_Flex";
export const CLASS_NONE = "CameraActivity_BlockNone";

export const CONTENT_TYPE_STILL = "still";
export const CONTENT_TYPE_VIDEO = "video";
export const CONTENT_TYPE_GIF = "gif";
